
import moment from 'moment'

moment.suppressDeprecationWarnings = true

const SERVER_FORMAT_DATE = 'YYYY-MM-DD'
const SERVER_FORMAT_DATETIME = 'YYYY-MM-DDTHH:mm:ssZ'
const SERVER_FORMAT_TIME = 'HH:mm:ss'

/** Convert a date/time string into a momentJs instance */
export function parseDateString (input) {
  let detectedFormat = null

  switch (input) {
    case 'now':
      return moment()

    case 'todayBOD':
      return moment().startOf('day')

    case 'todayEOD':
      return moment().endOf('day')

    default:
      // Date: YYYY-MM-DD
      if (/^\d{4}-\d{2}-\d{2}$/.test(input)) detectedFormat = SERVER_FORMAT_DATE

      // Date: DD-MM-YYYY
      if (/^\d{2}-\d{2}-\d{4}$/.test(input)) detectedFormat = 'DD-MM-YYYY'

      // Time: HH:mm:ss
      else if (/^(((([0-1][0-9])|(2[0-3])):?[0-5][0-9]:?[0-5][0-9]+$))/.test(input)) detectedFormat = SERVER_FORMAT_TIME

      // DateTime: YYYY-MM-DD[T]HH:mm:ss[Z]
      else if (/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})Z$/.test(input)) detectedFormat = SERVER_FORMAT_DATETIME
  }

  return detectedFormat && moment(input, detectedFormat)
}

export function format (inputDate, outputFormat, inputFormat) {
  if (!inputFormat) {
    const date = inputDate && parseDateString(inputDate)
    if (date) date.format(outputFormat)
  }
  return inputDate ? moment(inputDate, inputFormat).format(outputFormat) : ''
}
